var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqSpecialized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.5C21.2761 20.5 21.5 20.2761 21.5 20C21.5 19.7239 21.2761 19.5 21 19.5V20.5ZM18 19.5C17.7239 19.5 17.5 19.7239 17.5 20C17.5 20.2761 17.7239 20.5 18 20.5V19.5ZM19.0882 17V20H20.0882V17H19.0882ZM19.5882 20.5H21V19.5H19.5882V20.5ZM19.5882 19.5H18V20.5H19.5882V19.5Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5V5.5C7 4.94772 7.44772 4.5 8 4.5H9C9.55228 4.5 10 4.94772 10 5.5V6.5M14 6.5V5.5C14 4.94772 14.4477 4.5 15 4.5H16C16.5523 4.5 17 4.94772 17 5.5V6.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6H10V7H14V6ZM17 7H19C21.2091 7 23 8.79086 23 11V12C23 14.2091 21.2091 16 19 16H13.2361C13.4944 16.2885 13.6976 16.6274 13.8293 17H19C21.7614 17 24 14.7614 24 12V11C24 8.23858 21.7614 6 19 6H17V7ZM5 6H7V7H5C2.79086 7 1 8.79086 1 11V12C1 13.5702 1.90478 14.9291 3.22144 15.5838C2.94142 15.7903 2.69858 16.0443 2.50482 16.3339C1.00766 15.47 0 13.8527 0 12V11C0 8.23858 2.23858 6 5 6ZM7.23611 16C7.49436 16.2885 7.69759 16.6274 7.82929 17H8.17071C8.30241 16.6274 8.50564 16.2885 8.76389 16H7.23611Z",
    fill: "#3F3F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqSpecialized);
export default __webpack_public_path__ + "static/media/eq-specialized.72214a016128d720008b200703dd9ed3.svg";
export { ForwardRef as ReactComponent };